export function getLanguageKey(locale) {
  if (locale === 'en' || locale === 'en-US') {
    return 'en-US';
  }

  return 'de-DE';
}

export function localizeItem(item, localeOrLanguageKey) {
  if (!item || item.length === 0) {
    return '';
  }

  if (!Array.isArray(item)) {
    return item;
  }

  const languageKey = getLanguageKey(localeOrLanguageKey);

  let translation = item
    .find((x) => x.languageKey === languageKey)
    ?.translation?.trim();

  if (!translation) {
    translation = item.find((x) => x.translation)?.translation?.trim();
  }

  return translation ?? '';
}
